<template>
	<div class="detailPage">		
	
	<div class="head">			
		<div>
			<div class="left">LOGO</div>
			<div class="right">
				<div>
					<ul class="nav">
						<li><a href="">主机</a></li>
						<li><a href="">个人中心</a></li>
						<li><a href="">首页</a></li>
						<li><a href="">首页</a></li>
						<li><a href="">首页</a></li>
						<li><a href="">首页</a></li>
					</ul>
				</div>
				<div class="sear">
					<text class='search'></text>
					<input type="text" v-model="inputVal" :class="[{ inpuActive: isActive }]"  @mouseover ='inpuMouSeover' @mouseleave="inputMouseLeave"  @change="subSeach"/>
				</div>
			</div>
		</div>
	
	</div>
	<!-- 头部结束 -->
	<cpDetail></cpDetail>
		<!-- 产品图片或视频 -->
		<div class="huopin"><span :class="[{ huopinActive:huopinActive==0 }] " @click="tabT(0)">商品图片</span><span @click="tabT(1)" :class="[{ huopinActive:huopinActive==1 }] ">商品介绍</span></div>
		<!-- 简介 -->
		<div>
			<!-- tab1 -->
			<div class="jieshaoList" v-show="huopinActive==0">
				<ul>
					<li><img src="../assets/1431335355535.jpg" alt=""></li>
					<li><img src="../assets/brann.jpg" alt=""></li>
				</ul>
			</div>
			<!-- tab2 -->
			<div v-show="huopinActive==1" class="detailText">
				登录
				吕一
				video设置视频的宽高
				一般情况下
				
				但当设置video的宽高时，发现视频宽高并没有发生变化，因此设置 source的父元素宽高，让其填充video父元素。需要给video标签添加 style=“width:100%;height:300px;object-fit: fill”，即可。
				
				 
				
				object-fit属性的属性值：
				object-fit: fill |contain |cover|none |scale-down
				
				
				object-fit属性值的说明：
				object-fit主要适合于替换元素，比如：等。其默认值为fill。object-fill取值的说明如下：
				
				fill:此值为boject-fit的默认值，替换内容的大小被设置为填充元素的内容框，也就是说，元素的内容扩大到完全填充容器的外形尺寸，即使这打破其内在的宽高比。
				 contain：替换元素内容大小保持长宽比例填充元素内容容器，其具体对象大小被解析为一个包含元素的宽度和高度。也就是说，如果你在替换元素上设置一个明确的高度和宽度，此值将导致内容大小，完全在固定的比例显示，但仍在元素尺寸内显示。
				 cover：替换元素内容大小保持长宽比例填充元素内容容器，其具体对象大小被解析为覆盖整个元素的宽度和高度。也就是说，替换元素内容大小保持长宽比，但改变宽度和高度，以便完全覆盖内容元素。
				 none：替换元素内容不调整大小以适应内部元素的容器，内容完全忽略设置在元素上的任何高度和权重，并且仍在元素尺寸内显示。
				登录
				吕一
				video设置视频的宽高
				一般情况下
				
				但当设置video的宽高时，发现视频宽高并没有发生变化，因此设置 source的父元素宽高，让其填充video父元素。需要给video标签添加 style=“width:100%;height:300px;object-fit: fill”，即可。
				
				 
				
				object-fit属性的属性值：
				object-fit: fill |contain |cover|none |scale-down
				
				
				object-fit属性值的说明：
				object-fit主要适合于替换元素，比如：等。其默认值为fill。object-fill取值的说明如下：
				
				fill:此值为boject-fit的默认值，替换内容的大小被设置为填充元素的内容框，也就是说，元素的内容扩大到完全填充容器的外形尺寸，即使这打破其内在的宽高比。
				 contain：替换元素内容大小保持长宽比例填充元素内容容器，其具体对象大小被解析为一个包含元素的宽度和高度。也就是说，如果你在替换元素上设置一个明确的高度和宽度，此值将导致内容大小，完全在固定的比例显示，但仍在元素尺寸内显示。
				 cover：替换元素内容大小保持长宽比例填充元素内容容器，其具体对象大小被解析为覆盖整个元素的宽度和高度。也就是说，替换元素内容大小保持长宽比，但改变宽度和高度，以便完全覆盖内容元素。
				 none：替换元素内容不调整大小以适应内部元素的容器，内容完全忽略设置在元素上的任何高度和权重，并且仍在元素尺寸内显示。

			</div>
		</div>
	</div>
</template>

<script>
  import cpDetail from './cpDetail.vue'
	export default{
		name:'homePage',
		data(){
			return{
				isActive:false,
				inputVal:'',
				huopinActive:0
			}			
		},
		methods:{
			// 鼠标移入sear
			inpuMouSeover:function(){
				this.isActive = true
			},
			// 失去焦点
			shiqu:function(){
				if(this.inputVal ==''){
					this.isActive = false
				}
			},
			// 鼠标移出sear
			inputMouseLeave:function(){
			
			},
		
			// 提交搜索
			subSeach:function(e){
				console.log(e)
				this.$router.push('/search')
			},
			tabT:function(index){
				this.huopinActive = index
			}
			
		},
		components:{
			cpDetail
		}
	}
</script>

<style scoped>
	.detailPage{
		background-color: #EEEEEE;
		padding: 100px 0px 0px;
	}
	.detailText{
		width: 1000px;
		margin: auto;
		text-align: left;
		font-size: 16px;
		padding: 20px 10px;
		letter-spacing: 2px;
		box-sizing: border-box;
		line-height: 35px;
	}
		ul{
			padding: 0px;
			margin: 0px;
		}
		ul>li{list-style: none;}
	.huopin span{
		width: 100px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		display: inline-block;
		background-color:#EEEEEE;
		color: #333333;
		cursor: pointer;
		letter-spacing: 1px;
	}
	.huopin span.huopinActive{
		background-color:rgb(177,30,33);
		color: white;
	}
	.huopin{
		border-bottom: 2px solid rgb(177,30,33);
		width: 1000px;
		height: 40px;
		margin: 80px auto 0px;
		display: flex;
		justify-content: flex-start;
		box-sizing: content-box;
	}
	.jieshaoList{
		width: 1000px;
		margin: 0px auto 30px;
		background-color: rgb(246,246,246);
		padding: 20px;
		    box-sizing: border-box;
	}
	.jieshaoList img{
		width: auto;
		height: auto;
		max-height: 100%;
		max-width: 100%;
		vertical-align: middle;
	}
	/* 头部 */
	.head{
			width: 100%;
			height: 80px;
			line-height: 80px;		
			font-size: 14px;
			font-weight: 600;
			position: fixed;
			top: 0px;
			left: 0px;
			background-color: white;
			z-index: 30;
			box-shadow: 1px 1px 0.5px #EEEEEE;
		}
		.head>div{
			width: 1200px;
			margin: auto;
			display: flex;
			box-sizing: border-box;
			flex-direction: row;
			justify-content: space-between;
		}
		.head .left{
			
			width: 150px;
			background-color: rgb(39,85,161);
			color: white;
		}
		.head .right{
				display: flex;
				align-items: center;
		}
		.head .right .nav{
			width: 600px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 0px 20px 0px auto;
		}
		.head .right .nav li a{
			padding: 10px 0px;
		}
		
	.head	.right .nav li:hover>a{
			border-bottom: 1px solid rgb(39,85,161);
		}
	.head	.right .sear{
			margin: 0px 10px;
			width: 160px;
			text-align: left;
		}
	.head	.right .sear>input{
			width: 40px;
			background-color:#4876FF;
			color: white;
			border: 0px;
			outline: inherit;
			height: 25px;
			line-height: 25px;
			border-radius: 20px;
			background-image: url(../assets/sear.png);
			background-size: 15px 15px;
			background-repeat: no-repeat;
			background-position: 10px 4px;
			cursor:pointer;
			transition: all 1s;
			padding-left: 30px;
		}
	/*  */
	.head	.right .sear>input.inpuActive{
			width: 160px;
		}
		
</style>



// WEBPACK FOOTER //
// src/components/detail.vue